import { mutator } from 'satcheljs';
import { addPill, removePill, clearPills } from '../actions/pillActions';
import getStore from '../store/store';

export const addPillMutator = mutator(addPill, actionMessage => {
    const store = getStore();
    const newPill = actionMessage.pillData;

    let alreadyExists: boolean = false;
    store.allAddedPills.forEach(pill => {
        alreadyExists = alreadyExists || pill.id === newPill.id;
    });

    if (!alreadyExists) {
        store.allAddedPills.push(newPill);
        if (!store.viewState.barVisible) {
            store.viewState.barVisible = true;
        }
    }
});

export const removePillMutator = mutator(removePill, actionMessage => {
    const store = getStore();
    store.allAddedPills = store.allAddedPills.filter(value => {
        return value.id != actionMessage.pillId;
    });
});

export const clearPillsMutator = mutator(clearPills, actionMessage => {
    const store = getStore();
    while (store.allAddedPills.length > 0) {
        store.allAddedPills.pop();
    }
});
